__turbopack_context__.v({
  "linkItem": "Header-module__5JZlfG__linkItem",
  "links": "Header-module__5JZlfG__links",
  "search": "Header-module__5JZlfG__search",
  "searchOpen": "Header-module__5JZlfG__searchOpen",
});
